import { handleRangeDate2SingleDateRangeTimeFilterExtend } from '@intelligence/utils/dateUtils';
import {
  // 日期筛选器
  RANGE_TIME as RANGE_TIME_SELECT_FILTER,
  // 发布时间筛选器
  RELEASE_TIME as RELEASE_TIME_SELECT_FILTER,
  // 组合国家筛选器
  COMPOSED_COUNTRY_SELECT as COMPOSED_COUNTRY_SELECT_FILTER,
  // 单选区域筛选器
  SINGLE_AREA_SELECT as SINGLE_AREA_SELECT_FILTER,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';

import type { IDateType } from '@/pages/intelligence/types/common';

export const getInitialFormValue = (isOperate: boolean, filterExtend: any, defaultFormValue: any, isNitendo?: boolean) => {
  // 没有操作过筛选器，不继承
  if (!isOperate) return defaultFormValue ?? {};

  const filterExtendTmp = handleRangeDate2SingleDateRangeTimeFilterExtend(filterExtend);

  /** 各个筛选器的继承值 **/
  const rangeTimeFilterExtend = filterExtendTmp?.[RANGE_TIME_SELECT_FILTER];
  const composedCountrySelectFilterExtend = filterExtendTmp?.[COMPOSED_COUNTRY_SELECT_FILTER]?.value;
  const singleAreaSelectFilterExtend = filterExtendTmp?.[SINGLE_AREA_SELECT_FILTER];
  /** 各个筛选器的继承值 **/

  /** 各个筛选器的默认值 **/
  const rangeTimeDefault = defaultFormValue?.[RANGE_TIME_SELECT_FILTER];
  const releaseTimeDefault = defaultFormValue?.[RELEASE_TIME_SELECT_FILTER];
  const composedCountryDefault = defaultFormValue?.[COMPOSED_COUNTRY_SELECT_FILTER]?.value;
  const singleAreaDefault = defaultFormValue?.[SINGLE_AREA_SELECT_FILTER];
  /** 各个筛选器的默认值 **/

  return {
    // 日期筛选器
    [RANGE_TIME_SELECT_FILTER]: {
      type: rangeTimeFilterExtend?.filterType ?? rangeTimeDefault?.type,
      value: rangeTimeFilterExtend?.filterValue ?? rangeTimeDefault?.value,
    },
    // 发布时间筛选器固定按 Day 选择，不能沿用榜单日期的周/月粒度。
    [RELEASE_TIME_SELECT_FILTER]: {
      value: releaseTimeDefault?.value,
    },
    // 组合国家筛选器
    [COMPOSED_COUNTRY_SELECT_FILTER]: {
      value: {
        type: isNitendo && composedCountrySelectFilterExtend?.type === 'multiple' ? 'multiple' : composedCountrySelectFilterExtend?.type || composedCountryDefault?.type,
        countries:
          composedCountrySelectFilterExtend?.countries?.length >= 1
            ? composedCountrySelectFilterExtend?.countries
            : composedCountryDefault?.countries,
      },
    },
    // 单选区域筛选器
    [SINGLE_AREA_SELECT_FILTER]: {
      value: singleAreaSelectFilterExtend?.value || singleAreaDefault?.value,
    },
  };
};

export const getInitialInputList = (
  inputList: any[],
  cfg: { typeList: IDateType[]; composedCountryVisible?: boolean; composedCountryDisabled?: boolean; composedCountryDisabledLabel?: string },
) => {
  if (!Array.isArray(inputList)) return [];
  const { typeList, composedCountryVisible = true, composedCountryDisabled = false, composedCountryDisabledLabel = '' } = cfg || {};
  const inputListTmp = [...inputList];
  const typeListTmp = Array.isArray(typeList) && typeList.length ? typeList : ['date'];
  const rangeTimeFilterTmp = inputListTmp.find((item) => item?.type === RANGE_TIME_SELECT_FILTER);
  if (rangeTimeFilterTmp) {
    rangeTimeFilterTmp.showSelectType = typeListTmp?.length > 1;
    rangeTimeFilterTmp.typeList = typeListTmp;
  }

  const composedCountryFilterTmp = inputListTmp.find((item) => item?.type === COMPOSED_COUNTRY_SELECT_FILTER);
  if (composedCountryFilterTmp) {
    composedCountryFilterTmp.visible = composedCountryVisible ? 1 : 2;
    composedCountryFilterTmp.disabled = composedCountryDisabled;
    composedCountryFilterTmp.disabledLabel = composedCountryDisabled ? composedCountryDisabledLabel : '';
  }
  return inputListTmp;
};
